// conditionNode.js

import { BaseNode } from './BaseNode';
import { Position } from 'reactflow';

export const ConditionNode = ({ id, data }) => {
  const handles = [
    {
      type: 'target',
      position: Position.Left,
      id: `${id}-input`,
      style: { left: '-2px' }
    },
    {
      type: 'source',
      position: Position.Right,
      id: `${id}-true`,
      style: { top: '25%', right: '-2px' }
    },
    {
      type: 'source',
      position: Position.Right,
      id: `${id}-false`,
      style: { top: '75%', right: '-2px' }
    }
  ];

  const fields = [
    {
      name: 'condition',
      label: 'Condition',
      type: 'text',
      defaultValue: data?.condition || 'x > 0'
    },
    {
      name: 'operator',
      label: 'Operator',
      type: 'select',
      defaultValue: data?.operator || '>',
      options: [
        { value: '>', label: '>' },
        { value: '<', label: '<' },
        { value: '==', label: '==' },
        { value: '!=', label: '!=' },
        { value: '>=', label: '>=' },
        { value: '<=', label: '<=' }
      ]
    }
  ];

  return (
    <BaseNode
      id={id}
      data={data}
      type="condition"
      title="Condition"
      handles={handles}
      fields={fields}
    />
  );
};
